class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = Array.from(this.querySelectorAll('details.facets__disclosure'));
    this.onToggle = this.onToggle.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
  }

  connectedCallback() {
    this.detailsElements.forEach((details) => details.addEventListener('toggle', this.onToggle));
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    this.detailsElements.forEach((details) => details.removeEventListener('toggle', this.onToggle));
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  onToggle(event) {
    const openedDetails = event.currentTarget;
    if (!openedDetails.open) return;

    this.detailsElements.forEach((details) => {
      if (details !== openedDetails) details.removeAttribute('open');
    });
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.closeOpenFilters();
  }

  onDocumentKeydown(event) {
    if (event.key !== 'Escape') return;
    this.closeOpenFilters();
  }

  closeOpenFilters() {
    this.detailsElements.forEach((details) => details.removeAttribute('open'));
  }
}
class PriceRange extends HTMLElement {}
class FacetRemove extends HTMLElement {}

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
